import { AuthenticationProvider, LogContextProvider } from '@ecosystem/newron-client-lib';
import { feedback } from '@ecosystem/newron-design-system';
import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router';

import { Watcher } from '../components/watcher/Watcher';
import { getConfig } from '../config';
import { CLIENT_ROUTES } from '../constants';
import '../style/main.css';
import { MobileProvider } from '../pages/mobile/mobile.provider';
import { SocketProvider } from '../tools/SocketProvider';

const Main = React.lazy(() => import('../pages/main'));
const AcceptableUsePolicy = React.lazy(() => import('../pages/usePolicy'));
const AcceptUsePolicy = React.lazy(() => import('../pages/acceptUsePolicy'));
const PrivacyPolicy = React.lazy(() => import('../pages/privacyPolicy'));
const TermsAndConditions = React.lazy(() => import('../pages/terms'));
const AcceptTerms = React.lazy(() => import('../pages/acceptTerms'));
const ProfileEnrichment = React.lazy(() => import('../pages/profileEnrich'));
const AuthCallback = React.lazy(() => import('../pages/callback'));
const LoggedOut = React.lazy(() => import('../pages/loggedOut'));
const MagicLink = React.lazy(() => import('../pages/magicLink'));

export const CONFIG_KEY = 'NEWRON_PLATFORM_CONFIG';
const { API_NOTIFICATION_PATH } = getConfig();

function Root(): JSX.Element {
  return (
    <LogContextProvider mfeName="client-app">
      <AuthenticationProvider>
        <SocketProvider path={API_NOTIFICATION_PATH}>
          <MobileProvider>
            <React.Suspense fallback={<feedback.DotsLoader stretch height="100vh" />}>
              <Router>
                <Watcher />
                <Routes>
                  <Route path={CLIENT_ROUTES.LOGOUT} element={<LoggedOut />} />
                  <Route path={CLIENT_ROUTES.AUTH_CALLBACK} element={<AuthCallback />} />
                  <Route path={CLIENT_ROUTES.ACCEPT_TERMS} element={<AcceptTerms />} />
                  <Route path={CLIENT_ROUTES.PROFILE_ENRICH} element={<ProfileEnrichment />} />
                  <Route path={CLIENT_ROUTES.MAGIC_LINK} element={<MagicLink />} />
                  <Route path={CLIENT_ROUTES.ACCEPT_USE_POLICY} element={<AcceptUsePolicy />} />
                  <Route path={CLIENT_ROUTES.USE_POLICY} element={<AcceptableUsePolicy />} />
                  <Route path={CLIENT_ROUTES.PRIVACY} element={<PrivacyPolicy />} />
                  <Route path={CLIENT_ROUTES.TERMS} element={<TermsAndConditions />} />
                  <Route path="*" element={<Main />} />
                </Routes>
              </Router>
            </React.Suspense>
          </MobileProvider>
        </SocketProvider>
      </AuthenticationProvider>
    </LogContextProvider>
  );
}

export { Root };
